(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .directive('ignoreMouseWheel', function() {
            return {
                restrict: 'A',
                link: function(scope, element) {
                    element.bind('wheel', function() {
                        element[0].blur();
                    })
                }
            }
        });

})();
